"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryFactoryFromJS = exports.QueryFactory = void 0;
const immutable_1 = require("immutable");
exports.QueryFactory = (0, immutable_1.Record)({
    name: null,
    connectionId: null,
    connectionName: (0, immutable_1.Map)(),
    connectionType: null,
    description: (0, immutable_1.Map)(),
    id: null,
    properties: {},
    structure: {},
    resultData: []
});
const QueryFactoryFromJS = function (data) {
    return (0, exports.QueryFactory)({
        name: data.name,
        connectionId: data.connectionId,
        connectionType: data.connectionType,
        connectionName: (0, immutable_1.Map)(data.connectionName),
        description: (0, immutable_1.Map)(data.description),
        id: data.id,
        resultData: data.resultData
    });
};
exports.QueryFactoryFromJS = QueryFactoryFromJS;
//# sourceMappingURL=IQuery.js.map